<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-card style="">
            <v-card-text>
              <v-layout row wrap>
                <h3 style="text-align:left;margin-bottom: 10px">Shipping Instructions for Shipment No : AME/FF/17082002</h3>
                <v-btn flat class="primary" style="margin-left:600px;margin-bottom: 10px" v-on:click="back()">Back</v-btn>
              </v-layout>
              <v-layout row wrap align-center style="margin-top:20px;">
                <v-btn class="primary" v-on:click="sho1()" flat style="margin-left: 300px">Document</v-btn>
                <v-btn class="primary" v-on:click="sho2()" flat style="margin-left: 20px">Cargo Details</v-btn>
                <v-btn class="primary" v-on:click="sho3()" flat style="margin-left: 20px">Parties</v-btn>
                <v-btn class="primary" v-on:click="sho4()" flat style="margin-left: 20px">Payments</v-btn><v-btn class="primary" v-on:click="sho5()" flat style="margin-left: 20px">Review</v-btn>
              </v-layout>
              <v-flex xs12 v-show="show1">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Document Projects</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs2>
                          <label style="margin-right: 10px">Document Type</label>
                        </v-flex>
                        <v-flex xs4>
                          <v-select
                            :items="items"
                            label="Please Select"
                            outline
                          ></v-select>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs2>
                          <label style="margin-right: 10px">Issue Bill of Lading To</label>
                        </v-flex>
                        <v-flex xs4>
                          <v-select
                            :items="items"
                            label="Please Select"
                            outline
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show1">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <v-layout row wrap >
                        <h3 style="text-align: left;margin-bottom: 10px">B / L Print Instructions</h3>
                        <label style="margin-left:20px"> (Provided to The Carrier , Not Printed on Bill of Lading)</label>
                      </v-layout>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex d-flex>
                          <v-flex xs3>
                            <h3>B / L Type</h3>
                            <v-radio-group v-model="radioGroup">
                              <v-radio
                                    :label="`Original Non Negotiable`"
                                    :value="Original"
                                  ></v-radio>
                                  <v-radio
                                    :label="`Sea Way / Express`"
                                    :value="SeaWay"
                                    style="margin-top:50px"
                                  ></v-radio>
                                  <v-radio
                                    :label="`This is Standlone House Bill`"
                                    :value="Standlone_House_Bill"
                                    style="margin-top:50px"
                                  ></v-radio>
                            </v-radio-group>
                          </v-flex>
                          <v-flex xs3>
                            <h3>Freighted</h3>
                            <v-text-field
                              label=""
                              outline
                              style="margin-top:10px"
                            ></v-text-field>
                            <v-text-field
                              label=""
                              outline
                            ></v-text-field>
                            <v-text-field
                              label=""
                              outline
                            ></v-text-field>

                          </v-flex>
                          <v-flex xs3 style="margin-left:20px">
                            <h3>Unfreighted</h3>
                            <v-text-field
                              label=""
                              outline
                              style="margin-top:10px"
                            ></v-text-field>
                            <v-text-field
                              label=""
                              outline
                            ></v-text-field>
                            <v-text-field
                              label=""
                              outline
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs3>
                            <h3>B / L Comment</h3>
                            <v-textarea
                              outline
                              name="input"
                              label=""
                              value=""
                              style="margin-top:10px;margin-left:20px"
                            ></v-textarea>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:10px">
                        <v-flex xs3>
                          <label style="text-align: left">This is Standlone House Bill</label>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field
                                label=""
                                outline
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs4>
                          <label style="text-align: left;margin-left:20px">B / L Release Office</label>
                          <v-text-field
                                label="Please specify location"
                                outline
                                style="margin-left:20px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <label style="text-align: left;margin-left:20px">Print B / L as</label>
                          <v-text-field
                                label=""
                                outline
                                style="margin-left:20px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <label style="text-align: left;margin-left:20px">Requested Date of issue</label>
                          <v-menu
                            ref="menu"
                            :close-on-content-click="false"
                            v-model="menu"
                            :nudge-right="40"
                            :return-value.sync="date"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            style="margin-left:20px"
                          >
                            <v-text-field
                              slot="activator"
                              v-model="date"
                              label="Select Date"
                              prepend-icon="event"
                              readonly
                            ></v-text-field>
                            <v-date-picker v-model="date" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                              <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show1">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <v-layout row wrap >
                        <h3 style="text-align: left;margin-bottom: 10px">Request Certificate(s)</h3>
                      </v-layout>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex d-flex>
                          <v-flex xs4>
                            <v-checkbox v-model="selected" label="Built Date / Year" value="Built Date / Year"></v-checkbox>
                            <v-checkbox v-model="selected" label="Class & Classification" value="Class & Classification"></v-checkbox>
                            <v-checkbox v-model="selected" label="Conferenle" value="Conferenle"></v-checkbox>
                            <v-checkbox v-model="selected" label="Corrate Vessal Name" value="Corrate Vessal Name"></v-checkbox>
                            <v-checkbox v-model="selected" label="Institute Classification Clause (ICC)" value="Institute Classification Clause"></v-checkbox>
                            <v-checkbox v-model="selected" label="No Schedvled Cells" value="No Schedvled Cells"></v-checkbox>
                            <v-checkbox v-model="selected" label="Planned Eovte" value="Planned Eovte"></v-checkbox>
                            <v-checkbox v-model="selected" label="Regvlar Line Vessal" value="Regvlar Line Vessal"></v-checkbox>
                          </v-flex>
                          <v-flex xs4>
                            <v-checkbox v-model="selected" label="Sea Worthiness" value="Sea Worthiness"></v-checkbox>
                            <v-checkbox v-model="selected" label="Ship Searity Certificate (ISPS)" value="Ship Searity Certificate"></v-checkbox>
                            <v-checkbox v-model="selected" label="SMC and DOC" value="SMC and DOC"></v-checkbox>
                            <v-checkbox v-model="selected" label="Vessel Flag / Nationality" value="Vessel Flag / Nationality"></v-checkbox>
                            <v-checkbox v-model="selected" label="Vessel Not Prohibited from Entry" value="Vessel Not Prohibited from Entry"></v-checkbox>
                            <v-checkbox v-model="selected" label="Into Particular Port" value="Into Particular Port"></v-checkbox>
                            <v-checkbox v-model="selected" label="Vessel Owner" value="Vessel Owner"></v-checkbox>
                            <v-checkbox v-model="selected" label="Vessel P&I Club" value="Vessel P&I Club"></v-checkbox>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs3>
                          <label style="text-align: left;">Letter of Credit No.</label>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field
                                label=""
                                outline
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs3 style="margin-left:900px;margin-top:20px" v-show="show1">
                        <v-btn class="primary">Next</v-btn>
                </v-flex>
                <v-flex xs12 v-show="show2">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Cargo Details</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs4>
                          <label style="margin-right: 10px">Commodity:</label>
                        </v-flex>
                        <v-flex xs6>
                          <v-layout row wrap style="">
                            <label style="margin-right: 10px">Shipment Type</label>
                            <v-overflow-btn
                            :items="dropdown_list"
                            label=""
                            target="#dropdown-example"
                            style="margin-top:-20px;margin-left:20px"
                            ></v-overflow-btn>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2></v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show2">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs6></v-flex>
                        <v-flex xs6>
                          <v-layout row wrap>
                            <v-btn fab dark small color="primary" style="margin-left:200px;margin-top:-10px">
                              <v-icon dark>cloud_upload</v-icon>
                            </v-btn>
                            <label style="margin-left:10px">Upload Container Details File</label>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs12>
                          <v-layout row wrap style="">
                            <v-flex xs2 style="margin-left:20px">
                              <label style="margin-right: 10px">Container No.</label>
                              <v-text-field
                                label=""
                                outline
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs2 style="margin-left:20px">
                              <label style="margin-right: 10px">Package Count</label>
                              <v-text-field
                                label=""
                                outline
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs2 style="margin-left:20px">
                              <label style="margin-right: 10px">Package Type</label>
                              <v-overflow-btn
                              :items="dropdown_list"
                              label=""
                              target="#dropdown-example"
                              outline
                              style="margin-top:0px;margin-left:20px"
                              ></v-overflow-btn>
                            </v-flex>
                            <v-flex xs2 style="margin-left:20px">
                              <label style="margin-right: 10px">Cargo Gross Wt</label>
                              <v-text-field
                                label=""
                                outline
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs2 style="margin-left:20px">
                              <label style="margin-right: 10px">Shipper Seal</label>
                              <v-text-field
                                label=""
                                outline
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap style="margin-top:20px">
                            <v-flex xs12>
                              <a href="" style="margin-left:700px">save</a>
                              <a href="" style="margin-left:30px">+ Add More Details</a>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2></v-flex>
                      </v-layout>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs12>
                          <v-layout row wrap style="">
                            <v-flex xs2 style="margin-left:20px">
                              <label style="margin-right: 10px">Container No.</label>
                              <v-text-field
                                label=""
                                outline
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs2 style="margin-left:20px">
                              <label style="margin-right: 10px">Package Count</label>
                              <v-text-field
                                label=""
                                outline
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs2 style="margin-left:20px">
                              <label style="margin-right: 10px">Package Type</label>
                              <v-overflow-btn
                              :items="dropdown_list"
                              label=""
                              target="#dropdown-example"
                              outline
                              style="margin-top:0px;margin-left:20px"
                              ></v-overflow-btn>
                            </v-flex>
                            <v-flex xs2 style="margin-left:20px">
                              <label style="margin-right: 10px">Cargo Gross Wt</label>
                              <v-text-field
                                label=""
                                outline
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs2 style="margin-left:20px">
                              <label style="margin-right: 10px">Shipper Seal</label>
                              <v-text-field
                                label=""
                                outline
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap style="margin-top:20px">
                            <v-flex xs12>
                              <a href="" style="margin-left:700px">save</a>
                              <a href="" style="margin-left:30px">+ Add More Details</a>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2></v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show2">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex x2></v-flex>
                        <v-flex x4>
                          <v-layout column wrap>
                            <h3 style="margin-top:10px">Container 01</h3>
                            <v-flex style="margin-top:20px">
                              <label style="text-align: left">Container Number</label>
                              <v-text-field
                                label=""
                                outline
                              ></v-text-field>
                            </v-flex>
                            <v-flex>
                              <label style="text-align: left">Container Type</label>
                              <v-overflow-btn
                              :items="dropdown_list"
                              label=""
                              target="#dropdown-example"
                              style="margin-top:10px;"
                              outline
                              ></v-overflow-btn>
                            </v-flex>
                            <v-flex>
                              <v-layout row wrap style="margin-top:0px">
                                <v-dialog
                                    v-model="dialog"
                                    width="800"
                                  >
                                    <v-btn class="primary" style="margin-left:50px" slot="activator">Add Refeer Details</v-btn>
                                    <v-card>
                                      <v-card-title
                                        class="headline lighten-2"
                                        primary-title
                                        style="color:#1565C0"
                                      >
                                        Temperature Details
                                      </v-card-title>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-layout row wrap>
                                              <v-flex xs2 style="margin-left:80px">
                                                <label style="text-align: left">Temperature (C)</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                              </v-flex>
                                              <v-flex xs2 style="margin-left:20px">
                                                <label style="text-align: left">No. of Probes</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                              </v-flex>
                                              <v-flex xs2 style="margin-left:20px">
                                                <label style="text-align: left">Ventilator(m3/Hour)</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                              </v-flex>
                                              <v-flex xs2 style="margin-left:20px">
                                                <label style="text-align: left">Humidity (%)</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                 ></v-text-field>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                          <v-flex xs12 child-flex>
                                            <v-layout row wrap>
                                                <v-checkbox v-model="selected1" label="Cold Treatment" value="Cold Treatment" style="margin-left:80px"></v-checkbox>
                                                <v-checkbox v-model="selected1" label="Genset Export" value="Genset Export" style="margin-left:-400px"></v-checkbox>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>

                                      </v-card-text>

                                      <v-divider></v-divider>

                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          flat
                                          @click="dialog = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          color="primary"
                                          @click="dialog = false"
                                        >
                                          Save
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                  <v-dialog
                                    v-model="dialog1"
                                    width="800"
                                  >
                                    <v-btn class="primary" style="margin-left:50px" slot="activator">Add Oversize Details</v-btn>
                                    <v-card>
                                      <v-card-title
                                        class="headline lighten-2"
                                        primary-title
                                        style="color:#1565C0"
                                      >
                                        Oversize Cargo Dimension
                                      </v-card-title>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-layout row wrap>
                                              <v-flex xs2 style="margin-left:80px">
                                                <label style="text-align: left">Unit</label>
                                                  <v-overflow-btn
                                                  :items="dropdown_list"
                                                  label=""
                                                  target="#dropdown-example"
                                                  style="margin-top:10px;"
                                                  outline
                                                  ></v-overflow-btn>
                                              </v-flex>
                                              <v-flex xs2 style="margin-left:20px">
                                                <label style="text-align: left">Length</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                  style="margin-top:10px"
                                                 ></v-text-field>
                                              </v-flex>
                                              <v-flex xs2 style="margin-left:20px">
                                                <label style="text-align: left">Width</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                  style="margin-top:10px"
                                                 ></v-text-field>
                                              </v-flex>
                                              <v-flex xs2 style="margin-left:20px">
                                                <label style="text-align: left">Height</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                  style="margin-top:10px"
                                                 ></v-text-field>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>

                                      <v-divider></v-divider>

                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          @click="dialog1 = false"
                                        >
                                          Apply Details
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                              </v-layout>
                            </v-flex>
                            <v-flex style="margin-top:20px">
                              <label style="text-align: left;margin-top:10px">Container Net Wt</label>
                              <v-layout row wrap style="margin-top:10px">
                                <v-text-field
                                  label="Enter Weight"
                                  outline
                                  style="margin-top:0px"
                                ></v-text-field>
                                <v-overflow-btn
                                :items="dropdown_list"
                                label="kgs"
                                target="#dropdown-example"
                                style="margin-left:20px;"
                                outline
                                ></v-overflow-btn>
                              </v-layout>
                            </v-flex>
                            <v-flex>
                              <label style="text-align: left;margin-top:10px">Container Tare Wt</label>
                              <v-layout row wrap style="margin-top:10px">
                                <v-text-field
                                  label="Enter Number"
                                  outline
                                  style="margin-top:0px"
                                ></v-text-field>
                                <v-overflow-btn
                                :items="dropdown_list"
                                label="kgs"
                                target="#dropdown-example"
                                style="margin-left:20px;"
                                outline
                                ></v-overflow-btn>
                              </v-layout>
                            </v-flex>
                            <v-flex>
                              <label style="text-align: left;margin-top:10px">Container Gross Volume</label>
                              <v-layout row wrap style="margin-top:10px">
                                <v-text-field
                                  label="Enter Number"
                                  outline
                                  style="margin-top:0px"
                                ></v-text-field>
                                <v-overflow-btn
                                :items="dropdown_list"
                                label="Cbm"
                                target="#dropdown-example"
                                style="margin-left:20px;"
                                outline
                                ></v-overflow-btn>
                              </v-layout>
                            </v-flex>
                            <v-flex>
                              <v-layout row wrap style="margin-top:10px">
                                <v-flex xs6>
                                  <label style="text-align: left;margin-top:10px">Container Supplied</label>
                                  <v-overflow-btn
                                  :items="dropdown_list"
                                  label="Carrier Supplied"
                                  target="#dropdown-example"
                                  style="margin-left:0px;"
                                  outline
                                  ></v-overflow-btn>
                                </v-flex>
                                 <v-flex xs6>
                                  <label style="text-align: left;margin-top:10px">Wood Declaration</label>
                                  <v-overflow-btn
                                  :items="dropdown_list"
                                  label="Select One"
                                  target="#dropdown-example"
                                  style="margin-left:20px;"
                                  outline
                                  ></v-overflow-btn>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex>
                              <v-layout row wrap style="margin-top:10px">
                                <v-flex xs6>
                                  <label style="text-align: left;margin-top:10px">Shipper Seal Number</label>
                                  <v-overflow-btn
                                  :items="dropdown_list"
                                  label="Enter Number"
                                  target="#dropdown-example"
                                  style="margin-left:0px;"
                                  outline
                                  ></v-overflow-btn>
                                </v-flex>
                                 <v-flex xs6>
                                  <label style="text-align: left;margin-top:10px">Carrier Seal Number</label>
                                  <v-overflow-btn
                                  :items="dropdown_list"
                                  label="Enter Number"
                                  target="#dropdown-example"
                                  style="margin-left:20px;"
                                  outline
                                  ></v-overflow-btn>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex x4 style="margin-left:100px">
                          <v-layout column wrap>
                            <h3 style="margin-top:10px">Cargo 01</h3>
                            <v-flex style="margin-top:20px">
                              <label style="text-align: left;margin-top:10px">Package Count / Type (Outermost)</label>
                              <v-layout row wrap style="margin-top:0px">
                                <v-text-field
                                  label="Enter Count"
                                  outline
                                  style="margin-top:0px"
                                ></v-text-field>
                                <v-overflow-btn
                                :items="dropdown_list"
                                label="Select Type"
                                target="#dropdown-example"
                                outline
                                style="margin-left:20px;margin-top:10px"
                                ></v-overflow-btn>
                              </v-layout>
                            </v-flex>
                            <v-flex style="margin-top:0px">
                              <label style="text-align: left">Print on B / L as</label>
                              <v-text-field
                                label=""
                                outline
                              ></v-text-field>
                            </v-flex>
                            <v-flex style="margin-top:0px">
                              <label style="text-align: left">HS Code</label>
                              <v-text-field
                                label="Enter HS Code"
                                outline
                              ></v-text-field>
                            </v-flex>
                            <v-flex style="margin-top:0px">
                              <label style="text-align: left">Print on B / L as</label>
                              <v-textarea
                                outline
                                name="input"
                                label=""
                                value=""
                                style=""
                              ></v-textarea>
                            </v-flex>
                            <v-flex>
                              <v-layout row wrap style="margin-top:0px">
                                <v-dialog
                                    v-model="dialog2"
                                    width="1000"
                                  >
                                    <v-btn class="primary" style="margin-left:50px" slot="activator">Add Hazardous Details</v-btn>
                                    <v-card>
                                      <v-card-title
                                        class="headline lighten-2"
                                        primary-title
                                        style="color:#1565C0"
                                      >
                                        Dangerous Cargo Details
                                      </v-card-title>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-layout row wrap style="margin-top:20px">
                                        <v-flex x6>
                                          <v-layout column wrap>
                                            <v-flex style="margin-top:20px">
                                              <label style="text-align: left">IMO Class 1</label>
                                              <v-overflow-btn
                                              :items="dropdown_list"
                                              label="Please Specify IMO Class"
                                              target="#dropdown-example"
                                              style="margin-top:10px;"
                                              outline
                                              ></v-overflow-btn>
                                            </v-flex>
                                            <v-flex style="margin-top:0px">
                                              <label style="text-align: left">IMO Class 3</label>
                                              <v-overflow-btn
                                              :items="dropdown_list"
                                              label="Please Specify IMO Class"
                                              target="#dropdown-example"
                                              style="margin-top:10px;"
                                              outline
                                              ></v-overflow-btn>
                                            </v-flex>
                                            <v-flex style="margin-top:0px">
                                              <label style="text-align: left">Proper Shipping Name</label>
                                              <v-text-field
                                                label="(In Case of NOS, Please Provide Technical Name)"
                                                outline
                                                style="margin-top:0px"
                                              ></v-text-field>
                                            </v-flex>
                                            <v-flex style="margin-top:0px">
                                              <label style="text-align: left">General Comments</label>
                                              <v-textarea
                                                outline
                                                name="input"
                                                label=""
                                                value=""
                                                style=""
                                              ></v-textarea>
                                            </v-flex>
                                            <v-flex style="margin-top:0px">
                                              <label style="text-align: left">Emergency Contact Name</label>
                                              <v-text-field
                                                label="Please Specify"
                                                outline
                                                style="margin-top:0px"
                                              ></v-text-field>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex x6 style="margin-left:30px">
                                          <v-flex style="margin-top:20px">
                                              <label style="text-align: left">IMO Class 2</label>
                                              <v-overflow-btn
                                              :items="dropdown_list"
                                              label="Please Specify IMO Class"
                                              target="#dropdown-example"
                                              style="margin-top:10px;"
                                              outline
                                              ></v-overflow-btn>
                                          </v-flex>
                                          <v-flex style="margin-top:0px">
                                            <v-layout row wrap >
                                              <v-flex xs6>
                                                <label style="text-align: left">UN Code</label>
                                                <v-text-field
                                                  label="Specify 4 digit UN Code"
                                                  outline
                                                  style="margin-top:10px"
                                                ></v-text-field>
                                              </v-flex>
                                              <v-flex xs3>
                                                <label style="text-align: left;margin-left:10px">Flash Point</label>
                                                <v-text-field
                                                  label=""
                                                  outline
                                                  style="margin-top:10px;margin-left:10px"
                                                ></v-text-field>
                                              </v-flex>
                                              <v-flex xs3>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label=""
                                                target="#dropdown-example"
                                                style="margin-top:30px;margin-left:10px"
                                                outline
                                                ></v-overflow-btn>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>
                                          <v-flex style="margin-top:0px">
                                            <v-layout row wrap >
                                              <v-flex xs6>
                                                <label style="text-align: left;margin-left:10px">Packaging Group</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label="Please Specify"
                                                target="#dropdown-example"
                                                style="margin-top:0px;margin-left:0px"
                                                outline
                                                ></v-overflow-btn>
                                              </v-flex>
                                              <v-flex xs6>
                                                <label style="text-align: left;margin-left:10px">Aggregation State</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label="Please Specify"
                                                target="#dropdown-example"
                                                style="margin-top:0px;margin-left:10px"
                                                outline
                                                ></v-overflow-btn>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>
                                          <v-flex style="margin-top:0px">
                                            <v-layout row wrap >
                                              <v-flex xs6>
                                                <label style="text-align: left;margin-left:10px">Marine Pollutant</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label="Please Specify"
                                                target="#dropdown-example"
                                                style="margin-top:0px;margin-left:0px"
                                                outline
                                                ></v-overflow-btn>
                                              </v-flex>
                                              <v-flex xs6>
                                                <label style="text-align: left;margin-left:10px">Ltd.Qty. of Dang Goods</label>
                                                <v-overflow-btn
                                                :items="dropdown_list"
                                                label="Please Specify"
                                                target="#dropdown-example"
                                                style="margin-top:0px;margin-left:10px"
                                                outline
                                                ></v-overflow-btn>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>
                                          <v-flex style="margin-top:75px">
                                              <label style="text-align: left">Emergency Contact Name (Free Dial is allowed)</label>
                                              <v-text-field
                                                label="Please Specify"
                                                outline
                                                style="margin-top:0px"
                                              ></v-text-field>
                                        </v-flex>
                                        </v-flex>
                                        </v-layout>
                                      </v-card-text>

                                      <v-divider></v-divider>

                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          flat
                                          @click="dialog2 = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          color="primary"
                                          @click="dialog2 = false"
                                        >
                                          Save
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>

                              </v-layout>
                            </v-flex>
                            <v-flex style="margin-top:50px">
                              <label style="text-align: left;font-size:18px;">Cargo Gross Weight and Volume</label>
                              <p style="text-align: left">Cargo Gross Weight (Cargo + Packaging)</p>
                              <v-layout row wrap style="margin-top:0px">
                                <v-text-field
                                  label="Enter Weight"
                                  outline
                                  style="margin-top:0px"
                                ></v-text-field>
                                <v-overflow-btn
                                :items="dropdown_list"
                                label="kgs"
                                target="#dropdown-example"
                                style="margin-left:20px;"
                                outline
                                ></v-overflow-btn>
                              </v-layout>
                            </v-flex>
                            <v-flex style="margin-top:0px">
                              <p style="text-align: left">Cargo Gross Volume (Cargo + Packaging)</p>
                              <v-layout row wrap style="margin-top:0px">
                                <v-text-field
                                  label="Enter Number"
                                  outline
                                  style="margin-top:10px"
                                ></v-text-field>
                                <v-overflow-btn
                                :items="dropdown_list"
                                label="Cbm"
                                target="#dropdown-example"
                                style="margin-left:20px;"
                                ></v-overflow-btn>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex x2></v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show2">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Total</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs2 style="margin-left:150px">
                          <label style="text-align: left">Total Number of Containers</label>
                          <v-text-field
                            label=""
                            outline
                           ></v-text-field>
                        </v-flex>
                        <v-flex xs2 style="margin-left:30px">
                          <label style="text-align: left">Total Number of Packages</label>
                          <v-text-field
                            label=""
                            outline
                           ></v-text-field>
                        </v-flex>
                        <v-flex xs2 style="margin-left:30px">
                          <label style="text-align: left">Total Shipment Weight</label>
                          <v-text-field
                            label=""
                            outline
                           ></v-text-field>
                        </v-flex>
                        <v-flex xs2 style="margin-left:30px">
                          <label style="text-align: left">Total Shipment Volume</label>
                          <v-text-field
                            label=""
                            outline
                           ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs3 style="margin-left:900px;margin-top:20px" v-show="show2">
                  <v-layout row wrap>
                    <v-btn class="primary">Previous</v-btn>
                    <v-btn class="primary" style="margin-left:20px">Next</v-btn>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-show="show3">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Parties</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                         <v-flex xs2></v-flex>
                         <v-flex xs4>
                          <v-layout column wrap>
                            <v-flex xs6 style="margin-top:20px">
                              <v-flex>
                                <h3 style="margin-top:10px">Shipper</h3>
                                <label style="text-align: left">Container Number</label>
                                <v-overflow-btn
                                  :items="dropdown_list"
                                  label="Select Company"
                                  target="#dropdown-example"
                                  style="margin-top:10px;"
                                  outline
                                  ></v-overflow-btn>
                                  <v-textarea
                                    outline
                                    name="input"
                                    label=""
                                    value=""
                                    style="margin-top:0px;"
                                  ></v-textarea>
                                  <v-btn flat style="margin-left:200px;margin-top:-20px"><a>+ Edit Details</a></v-btn>
                              </v-flex>
                              <v-flex>
                                  <label style="text-align: left">First Notify Party (Optional)</label>
                                  <v-overflow-btn
                                    :items="dropdown_list"
                                    label="Select Notify Party"
                                    target="#dropdown-example"
                                    style="margin-top:10px;"
                                    outline
                                  ></v-overflow-btn>
                                  <v-textarea
                                    outline
                                    name="input"
                                    label=""
                                    value=""
                                    style="margin-top:0px;"
                                  ></v-textarea>
                                  <v-btn flat style="margin-left:200px;margin-top:-20px"><a>+ Edit Details</a></v-btn>
                              </v-flex>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex x4 style="margin-left:20px">
                          <v-layout column wrap>
                            <v-flex xs6 style="margin-top:20px">
                              <v-flex>
                                <h3 style="margin-top:10px">Consignee</h3>
                                <label style="text-align: left">Container Number</label>
                                <v-overflow-btn
                                  :items="dropdown_list"
                                  label="Select Company"
                                  target="#dropdown-example"
                                  style="margin-top:10px;"
                                  outline
                                ></v-overflow-btn>
                                <v-textarea
                                  outline
                                  name="input"
                                  label=""
                                  value=""
                                  style="margin-top:0px;"
                                ></v-textarea>
                                  <v-btn flat style="margin-left:200px;margin-top:-20px"><a>+ Edit Details</a></v-btn>
                              </v-flex>
                              <v-flex>
                                  <label style="text-align: left">Second Notify Party (Optional)</label>
                                  <v-overflow-btn
                                    :items="dropdown_list"
                                    label="Select Notify Party"
                                    target="#dropdown-example"
                                    style="margin-top:10px;"
                                    outline
                                  ></v-overflow-btn>
                                  <v-textarea
                                    outline
                                    name="input"
                                    label=""
                                    value=""
                                    style="margin-top:0px;"
                                  ></v-textarea>
                                  <v-btn flat style="margin-left:200px;margin-top:-20px"><a>+ Edit Details</a></v-btn>
                              </v-flex>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2></v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs3 style="margin-left:900px;margin-top:20px" v-show="show3">
                  <v-layout row wrap>
                    <v-btn class="primary">Previous</v-btn>
                    <v-btn class="primary" style="margin-left:20px">Next</v-btn>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-show="show4">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Frieght Charges</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs3>
                          <v-layout column wrap style="margin-top:20px">
                            <v-flex>
                              <label style="margin-left: 20px">Charge Type</label>
                              <v-checkbox v-model="selected2" label="Additional Charges" value="Additional Charges"></v-checkbox>
                              <v-checkbox v-model="selected2" label="Basic Frieght Ocean" value="Basic Frieght Ocean" style="margin-top:40px"></v-checkbox>
                              <v-checkbox v-model="selected2" label="Destination Haulage Charges" value="Destination Haulage Charges" style="margin-top:40px"></v-checkbox>
                              <v-checkbox v-model="selected2" label="Destination Port Charges" value="Destination Port Charges" style="margin-top:40px"></v-checkbox>
                              <v-checkbox v-model="selected2" label="Origin Port Charges" value="Origin Port Charges" style="margin-top:40px"></v-checkbox>
                              <v-checkbox v-model="selected2" label="Origin Haulage Charges" value="Origin Haulage Charges" style="margin-top:40px"></v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 style="margin-left:20px">
                          <v-layout column wrap style="margin-top:20px">
                            <v-flex>
                              <label style="margin-left: 20px">Freight Term</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 style="margin-left:20px">
                          <v-layout column wrap style="margin-top:20px">
                            <v-flex>
                              <label style="margin-left: 20px">Payer</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 style="margin-left:20px">
                          <v-layout column wrap style="margin-top:20px">
                            <v-flex>
                              <label style="margin-left: 20px">Payment Location</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label=""
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs3 style="margin-left:900px;margin-top:20px" v-show="show4">
                  <v-layout row wrap>
                    <v-btn class="primary">Previous</v-btn>
                    <v-btn class="primary" style="margin-left:20px">Next</v-btn>
                  </v-layout>
                </v-flex>
                <v-flex style="margin-top:20px" v-show="show5">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Review of Billing Lading For Ocean Transport or Multimodal Transport</h3>
                      <v-divider divider: true></v-divider>
                      <v-flex style="margin-top:20px">
                        <label>This is preview of your transport document. Please review it and go back to correct any misinformation. By clicking submit, you are agree to <a> Shipping Instruction Terms </a> </label>
                      </v-flex>
                      <v-flex style="margin-top:20px">
                        <v-layout row wrap>
                          <v-flex xs1></v-flex>
                          <v-flex xs3>
                            <v-responsive>
                              <img src="../assets/wynum_02@2x.png" style="margin-top:50px;width:50%;margin-left:20px">
                            </v-responsive>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs3>
                            <p style="text-align:center;margin-top:60px;margin-left:20px;margin-right:20px">BILL OF LADING FOR OCEAN TRANSPORT OR MULTIMODAL TRANSPORT</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs3>
                            <h3 style="margin-top:60px">Booking No:</h3>
                            <p style="text-align:center;margin-top:10px;margin-right:20px;margin-left:20px"> AME/SF/PI/156325</p>
                          </v-flex>
                          <v-flex xs1></v-flex>
                        </v-layout>
                        <v-divider divider: true></v-divider>
                        <v-layout row wrap>
                          <v-flex xs1></v-flex>
                          <v-flex xs3>
                            <h3 style="text-align:center;margin-top:60px;">Document Type</h3>
                            <p style="text-align:center;margin-top:10px;">Bill of Lading - Shipped on Board</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs3>
                            <h3 style="margin-top:60px">Bill of Lading No:</h3>
                            <p style="text-align:center;margin-top:10px;margin-right:20px;margin-left:20px"> AME/SF/PI/156325</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs3>
                            <h3 style="margin-top:60px">Contract No:</h3>
                            <p style="text-align:center;margin-top:10px;margin-right:20px;margin-left:20px">171502698</p>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-divider divider: true style="margin-top:20px;border-color: black"></v-divider>
                      <v-flex style="margin-top:20px">
                        <v-layout row wrap>
                          <v-flex xs2></v-flex>
                          <v-flex xs4>
                            <h3 style="margin-top:60px;margin-right: 20px">Shipper</h3>
                            <p style="text-align:center;margin-top:10px;margin-right: 20px">Suadi Ethlene & Polyethlene Co. P.O Box 35579</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs4>
                            <h3 style="margin-top:60px">Consignee</h3>
                            <p style="text-align:center;margin-top:10px;">Parekh Petrochemicals</p>
                            <p style="text-align:center;margin-top:10px;">Kandivali East, Mumbai, India</p>
                          </v-flex>
                          <v-flex xs2></v-flex>
                        </v-layout>
                        <v-divider divider: true></v-divider>
                        <v-layout row wrap>
                          <v-flex xs2></v-flex>
                          <v-flex xs4>
                            <h3 style="margin-top:60px;margin-right: 20px">First Notify Party</h3>
                            <p style="text-align:center;margin-top:10px;margin-right: 20px">Parekh Petrochemicals Kandivali East, Mumbai, India</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs4>
                            <h3 style="margin-top:60px">Second Notify Party</h3>
                            <p style="text-align:center;margin-top:10px;">Rohit Petrochemicals</p>
                            <p style="text-align:center;margin-top:10px;">Nagpur, India</p>
                          </v-flex>
                          <v-flex xs2></v-flex>
                        </v-layout>
                      </v-flex>
                      <v-divider divider: true></v-divider>
                      <v-flex>
                        <v-layout row wrap>
                          <v-flex xs3>
                            <h3 style="margin-top:60px">Vessel</h3>
                            <p style="text-align:center;margin-top:10px;">MAERSK TAURUS</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs3>
                            <h3 style="margin-top:60px">Voyage No</h3>
                            <p style="text-align:center;margin-top:10px;">1616</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs3>
                            <h3 style="margin-top:60px">Place of Receipt</h3>
                            <p style="text-align:center;margin-top:10px;">Dammam</p>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-divider divider: true></v-divider>
                      <v-flex>
                        <v-layout row wrap>
                          <v-flex xs3>
                            <h3 style="margin-top:60px">Port of Loading</h3>
                            <p style="text-align:center;margin-top:10px;">Dammam, Saudi Arabia</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs3>
                            <h3 style="margin-top:60px">Port of Discharge</h3>
                            <p style="text-align:center;margin-top:10px;">Jawaharlal Nehru, India</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs3>
                            <h3 style="margin-top:60px">Place of Delievery</h3>
                            <p style="text-align:center;margin-top:10px;">Jawaharlal Nehru, India</p>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-divider divider: true style="margin-top:20px;border-color: black"></v-divider>
                      <v-flex>
                        <h3 style="margin-top:30px">Particulars Finished By Shipper</h3>
                        <v-layout row wrap style="margin-top:20px">
                          <v-flex xs>
                            <h3>Kind of Packages : Description og Goods; Container No / Seal No</h3>
                            <p style="text-align:center;margin-top:10px;">1 Container said to contain 3960 Bags</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs>
                            <h3 style="margin-top:0px">Net Weight</h3>
                            <p style="text-align:center;margin-top:10px;">24750 KG</p>
                          </v-flex>
                          <v-divider vertical></v-divider>
                          <v-flex xs>
                            <h3 style="margin-top:0px">Gross Weight</h3>
                            <p style="text-align:center;margin-top:10px;">25369 KG</p>
                          </v-flex>
                           <v-divider vertical></v-divider>
                          <v-flex xs>
                            <h3 style="margin-top:0px">Measurement</h3>
                            <p style="text-align:center;margin-top:10px;">50 CBM</p>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-divider divider: true style="margin-top:20px;"></v-divider>
                      <v-flex>
                        <v-layout row wrap style="margin-top:20px">
                          <v-flex xs1></v-flex>
                          <v-flex xs5>
                            <h3>Additional Comments and Notifications</h3>
                            <v-textarea
                              outline
                              name="input"
                              label=""
                              value=""
                              style="margin-top:10px;margin-left:20px"
                            ></v-textarea>
                          </v-flex>
                          <v-flex xs5 style="margin-left:20px">
                            <h3 style="margin-bottom: 40px">Send email regarding the shipping instructions and verify copy</h3>
                            <label style="margin-top:0px">Partner Notification</label>
                            <v-text-field
                              label=""
                              outline
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1></v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs3 style="margin-left:900px;margin-top:20px" v-show="show5">
                  <v-layout row wrap>
                    <v-btn class="primary">Previous</v-btn>
                    <v-btn class="primary" style="margin-left:20px">Submit</v-btn>
                  </v-layout>
                </v-flex>
              </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      items: [1, 2, 3, 4, 5],
      dropdown_list: [1, 2, 3, 4, 5],
      radioGroup: 1,
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Date', value: 'calories' },
        { text: 'Time', value: 'fat' },
        { text: 'Event', value: 'carbs' },
        { text: 'Terminal', value: 'protein' },
        { text: 'Voyage No', value: 'iron' },
        { text: 'Transport Via', value: 'status' }
      ],
      desserts: [
        {
          no: '1',
          calories: '17-Oct-2016',
          fat: '10:00',
          carbs: 'Departs from Dammam Saudi Arabia',
          protein: 'Dammam',
          iron: '1612',
          status: 'MAERSK SHAM'
        },
        {
          no: '2',
          calories: '18-Oct-2016',
          fat: '10:00',
          carbs: 'Departs from Dammam Saudi Arabia',
          protein: 'Dammam',
          iron: '1612',
          status: 'MAERSK SHAM'
        },
        {
          no: '3',
          calories: '01-NOV-2016',
          fat: '10:00',
          carbs: 'Departs from Dammam Saudi Arabia',
          protein: 'Dammam',
          iron: '1612',
          status: 'MAERSK SHAM'
        }
      ],
      show1: true,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      selected: [''],
      selected1: [''],
      selected2: [''],
      dialog: false,
      dialog1: false,
      dialog2: false,
      activeColor: 'red',
      activeColor1: 'white'
    }
  },
  mounted () {
    console.log('bulkbooking page')
  },
  methods: {
    sho1 () {
      this.show1 = true
      this.show2 = false
      this.show3 = false
      this.show4 = false
      this.show5 = false
    },
    sho2 () {
      this.show2 = true
      this.show1 = false
      this.show3 = false
      this.show4 = false
      this.show5 = false
    },
    sho3 () {
      this.show3 = true
      this.show1 = false
      this.show2 = false
      this.show4 = false
      this.show5 = false
    },
    sho4 () {
      this.show4 = true
      this.show1 = false
      this.show2 = false
      this.show3 = false
      this.show5 = false
    },
    sho5 () {
      this.show5 = true
      this.show1 = false
      this.show2 = false
      this.show3 = false
      this.show4 = false
    },
    back () {
      this.$router.push('/Shippinginstructionsoverview')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Shippinginstructionsdocument.vue